function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { forwardRef, useEffect } from "react";
import { Container, Row, Col } from 'react-bootstrap';
import { Divider, Descriptions, Row as ARow, Col as ACol, QRCode, Tag, Radio, Alert, Table, Form, Image } from 'antd';
import { EyeFill, EarFill } from 'react-bootstrap-icons';
import 'bootstrap/dist/css/bootstrap.min.css';
import moment from 'moment';
import Moment from 'react-moment';
import Common from "./includes/Common";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
var RefDocument = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var candidat = _ref.candidat;
  var _Form$useForm = Form.useForm(),
    _Form$useForm2 = _slicedToArray(_Form$useForm, 1),
    form = _Form$useForm2[0];
  useEffect(function () {});
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Container, {
      children: /*#__PURE__*/_jsxs("div", {
        ref: ref,
        id: "printable",
        style: {
          padding: "15px"
        },
        children: [/*#__PURE__*/_jsxs(ARow, {
          children: [/*#__PURE__*/_jsx(ACol, {
            span: 5,
            children: /*#__PURE__*/_jsx(Image, {
              src: "/drawables/emgl.png",
              width: "190px",
              preview: false
            })
          }), /*#__PURE__*/_jsx(ACol, {
            span: 16,
            offset: 3,
            children: /*#__PURE__*/_jsxs("div", {
              style: {
                padding: "8px",
                borderRadius: "7px",
                color: "#EEE",
                background: "#A9675C",
                clear: "both"
              },
              children: [/*#__PURE__*/_jsx("h2", {
                children: /*#__PURE__*/_jsx("b", {
                  children: "FICHE DE REFERENCES"
                })
              }), /*#__PURE__*/_jsxs("span", {
                children: ["N\xBA ", candidat.candidate_code]
              })]
            })
          })]
        }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx(ARow, {
          gutter: 8,
          children: /*#__PURE__*/_jsx(ACol, {
            span: 24,
            children: /*#__PURE__*/_jsxs("div", {
              className: "pad cool-radius",
              children: [/*#__PURE__*/_jsxs("p", {
                style: {
                  fontSize: "16px"
                },
                children: ["Je soussign\xE9, ", /*#__PURE__*/_jsx("b", {
                  children: "Dr Assietou Rachid CAMARA"
                }), ", Certifie avoir examin\xE9 ", /*#__PURE__*/_jsx("b", {
                  children: candidat.name
                }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsxs(Descriptions, {
                  contentStyle: {
                    background: "#FFF"
                  },
                  labelStyle: {
                    background: "#EEE"
                  },
                  bordered: true,
                  column: 1,
                  size: "small",
                  children: [/*#__PURE__*/_jsx(Descriptions.Item, {
                    contentStyle: {
                      fontSize: "26px",
                      fontWeight: "bold",
                      color: "#DC7C47"
                    },
                    label: /*#__PURE__*/_jsx("b", {
                      children: "CATEGORIE"
                    }),
                    children: candidat.category != 0 && candidat.category != "0" && candidat.category
                  }), /*#__PURE__*/_jsxs(Descriptions.Item, {
                    label: /*#__PURE__*/_jsx("b", {
                      children: "D. NAISSANCE"
                    }),
                    children: [/*#__PURE__*/_jsx(Moment, {
                      date: candidat.birthdate,
                      format: "DD/MM/YYYY"
                    }), " "]
                  }), /*#__PURE__*/_jsx(Descriptions.Item, {
                    label: /*#__PURE__*/_jsx("b", {
                      children: "POSTE DE TRAVAIL"
                    }),
                    children: candidat.job
                  }), /*#__PURE__*/_jsx(Descriptions.Item, {
                    label: /*#__PURE__*/_jsx("b", {
                      children: "NUMERO"
                    }),
                    children: candidat.mobile_first
                  }), /*#__PURE__*/_jsx(Descriptions.Item, {
                    label: /*#__PURE__*/_jsx("b", {
                      children: "MATRICULE"
                    }),
                    children: candidat.matricule
                  }), /*#__PURE__*/_jsx(Descriptions.Item, {
                    label: /*#__PURE__*/_jsx("b", {
                      children: "LIEU DE RESIDENCE"
                    }),
                    children: candidat.address
                  }), /*#__PURE__*/_jsxs(Descriptions.Item, {
                    label: /*#__PURE__*/_jsx("b", {
                      children: "MOTIF"
                    }),
                    children: [candidat.reason == 0 && /*#__PURE__*/_jsx("span", {
                      children: "VISITE ANNUELLE"
                    }), " ", candidat.reason == 1 && /*#__PURE__*/_jsx("span", {
                      children: "PRE-EMBAUCHE"
                    }), " ", candidat.reason == 2 && /*#__PURE__*/_jsx("span", {
                      children: "PERMIS DE TRAVAIL"
                    }), " ", candidat.reason == 3 && /*#__PURE__*/_jsx("span", {
                      children: "TRAVAILLEURS JOURNALIERS"
                    })]
                  }), /*#__PURE__*/_jsx(Descriptions.Item, {
                    label: /*#__PURE__*/_jsx("b", {
                      children: "ENTREPRISE"
                    }),
                    children: candidat.company.label
                  })]
                }), /*#__PURE__*/_jsx("br", {})]
              }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsxs(_Fragment, {
                children: [/*#__PURE__*/_jsx("h4", {
                  style: {
                    textAlign: "center"
                  },
                  children: /*#__PURE__*/_jsx("b", {
                    children: "Observation:"
                  })
                }), /*#__PURE__*/_jsx("p", {
                  children: /*#__PURE__*/_jsx("b", {
                    style: {
                      color: "#9D614B"
                    },
                    children: "Merci de contacter le service m\xE9dical de Medvie pour un avis sp\xE9cialis\xE9."
                  })
                })]
              }), /*#__PURE__*/_jsx("br", {}), candidat.conclusion.prevention_tips != null && /*#__PURE__*/_jsx(Tag, {
                type: "info",
                banner: true,
                message: candidat.conclusion.prevention_tips
              }), /*#__PURE__*/_jsxs("h6", {
                style: {
                  textAlign: "center"
                },
                children: [/*#__PURE__*/_jsx("b", {
                  children: "Conakry, le "
                }), candidat.company_id != 31 ? /*#__PURE__*/_jsx(Moment, {
                  format: "DD/MM/YYYY"
                }) : /*#__PURE__*/_jsx(Moment, {
                  date: candidat.created_at,
                  format: "DD/MM/YYYY"
                })]
              }), /*#__PURE__*/_jsx("br", {})]
            })
          })
        }), /*#__PURE__*/_jsxs(ARow, {
          children: [/*#__PURE__*/_jsx(ACol, {
            span: 8,
            children: /*#__PURE__*/_jsxs("div", {
              style: {
                textAlign: 'center'
              },
              children: [/*#__PURE__*/_jsx("h5", {
                children: /*#__PURE__*/_jsx("b", {
                  children: "Le M\xE9decin du travail"
                })
              }), (candidat.status == 2 || candidat.conclusion.conclusion == 4 || candidat.conclusion == 12) && /*#__PURE__*/_jsx(Image, {
                src: "/drawables/dsign2.png",
                preview: false,
                width: "320px"
              })]
            })
          }), /*#__PURE__*/_jsx(ACol, {
            span: 8,
            children: /*#__PURE__*/_jsx("div", {
              style: {
                textAlign: "center",
                paddingLeft: "85px"
              },
              children: /*#__PURE__*/_jsx(QRCode, {
                errorLevel: "H",
                size: 150,
                value: "https://rio.medvieexpert.com/#/check/" + candidat.id
              })
            })
          })]
        }), /*#__PURE__*/_jsxs(Row, {
          children: [/*#__PURE__*/_jsx(Col, {
            style: {
              "float": 'left',
              width: '46%'
            },
            lg: 6,
            md: 6,
            sm: 6
          }), /*#__PURE__*/_jsx(Col, {
            style: {
              "float": 'left',
              width: '46%'
            },
            className: "g-col-6",
            lg: 6,
            md: 6,
            sm: 6
          })]
        }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx(Alert, {
          type: "info",
          size: "large",
          message: /*#__PURE__*/_jsx("b", {
            children: "N.B."
          }),
          description: /*#__PURE__*/_jsxs("div", {
            children: ["Les candidats ref\xE9r\xE9s sont plac\xE9s en inaptitude provisoir dans l'attente de resultats suppl\xE9mentaires", /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsxs("b", {
              children: ["Adresse: Prima Center, Commune de Ratoma, Conakry, R\xE9p. de Guin\xE9e", /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("b", {
                children: "Tel: +224 621 72 49 21 - E-mail: info@medviegn.com"
              })]
            })]
          })
        })]
      })
    }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {})]
  });
});
export default RefDocument;